import React from 'react'

import EditSizeForm from '../../modules/Size/components/EditSizeForm'
export default function EditSizePage() {
  return <EditSizeForm />
}
